import { createSlice } from '@reduxjs/toolkit';
import checkRes from '../../utils/checkRes';
import {
  changeClientStatusAction,
  createClientAction,
  deleteClientAction,
  getClientsAction,
  getSingleClientsAction,
  updateClientAction
} from './clientsSliceThunkApi';

const initialState = {
  /////////////////////
  isLoadingTableData: false,
  fetchedTableData: [],
  fetchedSingleClient: null,
  fetchDataCount: 0,
  postFormModalOpened: false,
  watchClientPackage: null,
  deleteModalOpened: false,
  editEndDateModalOpened: false,
  invoiceModalOpened: false,
  isSubmitting: false,
  selectedTableRow: null,
  selectedClientInvoice: null,
  confirmModal: {
    opened: false,
    type: ''
  },
  
  //
  tablePagination: {
    current_page: 1,
    par_page: 0,
    total: 0
  }
};

const clientsSlice = createSlice({
  name: 'clientsSlice',
  initialState,
  reducers: {
    setPostFormModalOpened: (sliceState, action) => {
      window.scrollTo(0, 0);
      sliceState.postFormModalOpened = action.payload;
    },
    setFetchDataCount: (sliceState, action) => {
      sliceState.fetchDataCount = action.payload;
    },
    setWatchClientPackage: (sliceState, action) => {
      sliceState.watchClientPackage = action.payload;
    },
    setDeleteModalOpened: (sliceState, action) => {
      sliceState.deleteModalOpened = action.payload;
    },  setEditEndDateModalOpened: (sliceState, action) => {
      sliceState.editEndDateModalOpened = action.payload;
    },
    
    setClientInvoiceModalOpened: (sliceState, action) => {
      sliceState.invoiceModalOpened = action.payload;
    },
    setSelectedTableRow: (sliceState, action) => {
      sliceState.selectedTableRow = action.payload;
    },
    setSelectedClientInvoice: (sliceState, action) => {
      sliceState.selectedClientInvoice = action.payload;
    },
    setConfirmModal: (sliceState, action) => {
      sliceState.confirmModal = {
        opened: action.payload.opened,
        type: action.payload.type
      };
    },
    setSelectedTab: (sliceState, action) => {
      sliceState.selectedTab = action.payload;
    }
  },
  extraReducers: {
    // get clients
    [getClientsAction.pending]: (state) => {
      state.isLoadingTableData = true;
    },
    [getClientsAction.fulfilled]: (state, action) => {
      state.isLoadingTableData = false;
      const data = action?.payload?.res?.data?.data;
      state.fetchedTableData = data?.data;
      if (data?.pagination) state.tablePagination = data.pagination;
      // if (data?.pagination) state.tablePagination = data.pagination;
    },
    [getClientsAction.rejected]: (state, action) => {
      state.isLoadingTableData = false;
    },
    // get single client
    [getSingleClientsAction.pending]: (state) => {
      state.isLoadingTableData = true;
    },
    [getSingleClientsAction.fulfilled]: (state, action) => {
      state.isLoadingTableData = false;
      const data = action?.payload?.res?.data?.data;
      state.fetchedSingleClient = data;
      // if (data?.pagination) state.tablePagination = data.pagination;
    },
    [getSingleClientsAction.rejected]: (state, action) => {
      state.isLoadingTableData = false;
    },
    //
    // change client status
    [changeClientStatusAction.pending]: (state) => {
      state.isSubmitting = true;
    },
    [changeClientStatusAction.fulfilled]: (state, action) => {
      state.isSubmitting = false;
      const res = action.payload?.res;
      const isClientPage = action.payload?.isClientPage;
      const cb = action.payload?.cb;
      if (checkRes(res)) {
        state.selectedTableRow = null;
        if (isClientPage) state.fetchDataCount += 1;
        if (cb && typeof cb === 'function') cb();
        state.confirmModal = {
          opened: false,
          type: ''
        };
      }
    },
    [changeClientStatusAction.rejected]: (state) => {
      state.isSubmitting = false;
    },
    //
    // create client
    [createClientAction.pending]: (state) => {
      state.isSubmitting = true;
    },
    [createClientAction.fulfilled]: (state, action) => {
      state.isSubmitting = false;
      const res = action.payload?.res;
      if (checkRes(res)) {
        state.fetchDataCount += 1;
        state.postFormModalOpened = false;
      }
    },
    [createClientAction.rejected]: (state) => {
      state.isSubmitting = false;
    },
    //
    // update client
    [updateClientAction.pending]: (state) => {
      state.isSubmitting = true;
    },
    [updateClientAction.fulfilled]: (state, action) => {
      state.isSubmitting = false;
      const res = action.payload?.res;
      if (checkRes(res)) {
        state.selectedTableRow = null;
        state.fetchDataCount += 1;
        state.postFormModalOpened = false;
      }
    },
    [updateClientAction.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // delete client
    [deleteClientAction.pending]: (state) => {
      state.isSubmitting = true;
    },
    [deleteClientAction.fulfilled]: (state, action) => {
      state.isSubmitting = false;
      const res = action.payload.res;
      const isClientPage = action.payload?.isClientPage;
      const cb = action.payload?.cb;
      if (checkRes(res)) {
        state.selectedTableRow = null;
        if (isClientPage) state.fetchDataCount += 1;
        if (cb && typeof cb === 'function') cb();
        state.deleteModalOpened = false;
      }
    },
    [deleteClientAction.rejected]: (state) => {
      state.isSubmitting = false;
    }
    //
  }
});

const clientsReducer = clientsSlice.reducer;

export const {
  setPostFormModalOpened,
  setFetchDataCount,
  setWatchClientPackage,
  setDeleteModalOpened,setEditEndDateModalOpened,
  setClientInvoiceModalOpened,
  setSelectedTableRow,
  setSelectedClientInvoice,
  setConfirmModal,
  setSelectedTab
} = clientsSlice.actions;

export default clientsReducer;
